import { firstResponderMessagesEN } from './lib/intl/en-US';

export const programId = '5eab3ec05eb2c21ab7a03610';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': firstResponderMessagesEN,
    },
};
